<template>
  <Content>
    <div id="task_template">
      <Card v-for="(panelItem,index) in packagePanelConfigs" v-if="packagePanelConfigs&&packagePanelConfigs.length>0">
        <Row style="max-height:40px">
          <Col span="24">
            <FormItem label="体检类型" :label-width="70" >
              <el-select v-model.trim="medicalType" placeholder="体检类型" :disabled="packageDisabled"
                         clearable filterable size="small" transfer="true" :popper-append-to-body="false"
                         style="width: 100%" @change="(val)=>{changePhysicalType(val, panelItem)}" class="input-disabled">
                <el-option v-for="item in physicalTypeList" :key="item.code" :label="item.name" :value="item.code"
                           @click.native="handlePhysicalType(item)" style="width:100%;z-index: 9999;"/>
              </el-select>
            </FormItem>
          </Col>
        </Row>

        <Row style="max-height:40px">
          <Col span="24">
            <FormItem label="体检套餐" :label-width="70" >
              <el-select v-model.trim="packagePanelConfigs[index].search" placeholder="请选择体检套餐" :disabled="packageDisabled"
                         filterable size="small" transfer="true" :popper-append-to-body="false"
                         style="width: 100%" @click.native="(val,propName)=>{changePackages(val,propName,index)}" class="input-disabled">
                <el-option v-for="item in packagesNames" :key="item.value" :label="item.label" :value="item.value"
                           style="width:100%;z-index: 9999;"/>
              </el-select>
            </FormItem>
          </Col>
        </Row>

        <Row style="max-height:40px" v-if="((!medicalType || medicalType === 2) && bloodTubeShow && !packageDisabled) || (packageDisabled && bloodTubeRemark)">
          <Col span="24">
            <FormItem label="试管" :label-width="70" >
              <el-badge :value="item.count" class="item" v-for="item in bloodTubes" v-if="item.show && item.count > 0" style="margin-right: 15px;margin-bottom: 5px;">
                <el-button size="small" :style="{'background-color':item.color,'border-color':item.color,'color':'#fff'}">{{ item.name }}</el-button>
              </el-badge>
              <el-button type="text" style="color: #409EFF;" @click="bloodTubeWindow = true" v-if="!packageDisabled">配置试管</el-button>
              <el-button type="text" style="margin-left: 10px;color: #f43f3b;" @click="clearBloodTube" v-if="!packageDisabled && bloodTubeClearShow">清空配置</el-button>
            </FormItem>
          </Col>
        </Row>

        <Row>
          <Col span="24">
            <TaskDetailEditTabPanel ref="detailEditTabPanel" :show-tabs="['physicalProject', 'lisProject']"
                                    :model="'table'" :key="`edp${index}`" :maxHeight="'430px'"
                                    :packagesId.sync="panelItem.search.packagesId"
                                    :taskProjects="panelItem.taskProjects"
                                    :taskLisProjects="panelItem.taskLisProjects"
                                    :projectIds.sync="panelItem.projectIds"
                                    :lisProjectIds.sync="panelItem.lisProjectIds"
                                    :medicalType.sync="medicalType"
                                    :localApplicableAgeList="applicableAgeList"
                                    :disabled="packageDisabled?true:!itemDisabled&&panelItem.search.packagesId&&panelItem.search.packagesId?false:true"
                                    @setTaskProjects="setTaskProject"/>
          </Col>
        </Row>
      </Card>
    </div>

    <Modal v-model="bloodTubeWindow" width="20%" title="试管" :styles="{'top':'60px','text-align': 'center'}" :mask-closable="false">
      <div style="text-align:left;margin-bottom: 8px;" v-for="item in bloodTubeList" v-if="item.show">
        <span :style="{'color': item.color, 'font-size': '16px'}">{{ item.name }} </span><el-input-number v-model="item.count" :min="1" :max="9" label="请输入试管根数"/> 根
      </div>
      <div slot="footer">
        <el-button  @click="bloodTubeWindow = false">取 消</el-button>
        <Button type="primary" @click="setBloodTube">确定</Button>
      </div>
    </Modal>

  </Content>
</template>
<script>
import TaskDetailEditTabPanel from "@/views/preScreening/taskDetail/TaskDetailEditTabPanel.vue"
import Integer from "@zxing/library/es2015/core/util/Integer";
export default {
  name: "TaskTemplate",
  components: {TaskDetailEditTabPanel},
  data() {
    return {
      loading: false,
      bloodTubeWindow: false,
      medicalType: "",
      bloodTubeShow: false,
      data: [],
      bloodTubes:[
        {name: '红管', color: '#CE1616', show: false, count:0},
        {name: '绿管', color: '#16B94E', show: false, count:0},
        {name: '紫管', color: '#540BA2', show: false, count:0},
        {name: '蓝管', color: '#006DFD', show: false, count:0},
        {name: '黑管', color: '#100F0FFF', show: false, count:0},
        {name: '黄管', color: '#BDAE0C', show: false, count:0},
        {name: '灰管', color: '#9BA0AB', show: false, count:0},
        {name: '橙管', color: '#BF7007', show: false, count:0},
      ],
      bloodTubeClearShow: false,
      packagePanelConfigs: [],
      taskProjectList: [],
      physicalTypeList:[
        {name: '只做常规,不抽血', code: 1},
        {name: '只抽血,不做常规', code: 2},
      ],
      bloodTubeList:[
        {name: '红管', code: 1, color: '#CE1616', show: false, count:0},
        {name: '绿管', code: 2, color: '#16B94E', show: false, count:0},
        {name: '紫管', code: 3, color: '#540BA2', show: false, count:0},
        {name: '蓝管', code: 4, color: '#006DFD', show: false, count:0},
        {name: '黑管', code: 5, color: '#100F0FFF', show: false, count:0},
        {name: '黄管', code: 6, color: '#BDAE0C', show: false, count:0},
        {name: '灰管', code: 7, color: '#9BA0AB', show: false, count:0},
        {name: '橙管', code: 8, color: '#BF7007', show: false, count:0},
      ],
    };
  },
  props: {
    physicalType: {
      type: Integer,
      default: null
    },
    bloodTubeRemark: {
      type: String,
      default: null
    },
    packageDisabled: {
      type: Boolean,
      default: true
    },
    itemDisabled: {
      type: Boolean,
      default: true
    },
    packagesNames: {
      type: Array,
      default: () => {
        return [];
      }
    },
    applicableAgeList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    taskProject: {
      type: Array,
      default: () => {
        return [];
      }
    },
  },
  watch: {
    physicalType: {
      handler(newVal, oldVal) {
        this.medicalType = newVal;
      }
    },
    bloodTubeRemark:{
      handler(newVal, oldVal) {
        this.initBloodTube(newVal);
      }
    },
    packagesNames: {
      handler(newVal, oldVal) {
        this.$props.packagesNames = newVal;
      }
    },
    taskProject: {
      handler(newVal, oldVal) {
        let _this = this;
        this.packagePanelConfigs = [];
        // this.initBloodTube(this.bloodTubeRemark);

        if (!newVal || newVal.length == 0) {
          return;
        }

        for (let i = 0; i < newVal.length; i++) {
          let item = newVal[i];
          let projectIds = [];
          if (item.taskProjects) {
            item.taskProjects.forEach(project => {
              project.disabled = _this.itemDisabled;
              if (project.status === 2 && project.projectId) {
                projectIds.push(project.projectId)
              }
            });
          }

          let lisProjectIds = [];
          if (item.taskLisProjects) {
            item.taskLisProjects.forEach(lisProject => {
              lisProject.disabled = _this.itemDisabled;
              if (lisProject.status === 2 && lisProject.lisProjectId) {
                lisProjectIds.push(lisProject.lisProjectId)
              }
            });
          }

          this.packagePanelConfigs.push({
            taskProjects: item.taskProjects,
            taskLisProjects: item.taskLisProjects,
            projectIds: projectIds,
            lisProjectIds: lisProjectIds,
          })
          this.setSearchEle(i, item.packagesId)
        }
      }
    },
  },
  created() {
  },
  mounted() {

  },
  methods: {
    initBloodTube(bloodTubeRemark){
      if(bloodTubeRemark){
        let bloodTubes = bloodTubeRemark.split("、");
        this.bloodTubeClearShow = false;
        for (let index = 0; index < this.bloodTubeList.length; index++) {
          let bloodTube = this.bloodTubeList[index];

          for (let i = 0; i < bloodTubes.length; i++) {
            let name = bloodTubes[i].toString();
            let count = this.getNumPrefix(name);
            let bloodTubeName = name.replace(count, "");

            if(bloodTube.name.indexOf(bloodTubeName) > -1 && count && count.length > 0){
              bloodTube.count = count;
              this.bloodTubes[index].count = count;

              this.bloodTubeClearShow = true;
              break;
            }
          }
        }
      }else{
        this.bloodTubeClearShow = false;
        for (let index = 0; index < this.bloodTubeList.length; index++) {
          let bloodTube = this.bloodTubeList[index];
          if(bloodTube.count > 0){
            bloodTube.count = 1;
          }
          this.bloodTubes[index].count = 0;
        }
      }
    },
    setSearchEle(index, val) {
      this.packagePanelConfigs[index].search = {packagesId: val ? val : ''}
      this.packagePanelConfigs[index].searchElem = [
        {
          label: '体检套餐',
          prop: "packagesId",
          placeholder: '请选择体检套餐',
          labelWidth: 70,
          element: 'select',
          option: this.$props.packagesNames,
          events: 'changeend',
          elemWidth: 'width: 100%',
          disabled: this.packageDisabled,
        },
      ]
    },
    changePackages(val, propName, index) {
      if (!val) {
        return;
      }
      /*_packagesList({packagesId: val}).then(res => {
        if (res.errcode === 1) {
          this.$emit("setPackageId", val)
          this.packagePanelConfigs[index].packagesId = res.data.packagesId.toString();
          this.packagePanelConfigs[index].packagesName = res.data.packagesName
          this.packagePanelConfigs[index].projectIds = res.data.projectIds
          this.packagePanelConfigs[index].lisProjectIds = res.data.lisProjectIds
        }
      })*/
    },
    setTaskProject(packageId, paramName, datas, refresh) {
      this.bloodTubeShow = false;
      for (let i = 0; i < this.packagePanelConfigs.length; i++) {
        if ((this.packagePanelConfigs[i].search.packagesId + '') === (packageId + '')){
          this.packagePanelConfigs[i][paramName] = datas
        }
      }

      if(paramName === 'taskLisProjects' && datas && datas.length > 0) {
        for (let i = 0; i < datas.length; i++) {
          let item = datas[i];
          for (let index = 0; index < this.bloodTubeList.length; index++) {
            let bloodTube = this.bloodTubeList[index];
            if(bloodTube.name == item.bloodTubeName && item.status == 2){
              bloodTube.show = true;
              this.bloodTubes[index].show = true;
            }
          }

          if(item.status == 2 && item.projectType == 2){
            this.bloodTubeShow = true;
          }
        }

        if(!this.bloodTubeShow && refresh){
          this.$emit("setBloodTubeCount", "")
        }
      }
    },
    changePhysicalType(val, panelItem){
      this.$emit("setPhysicalType", val)
      if(!val){
        let projectIds = [];
        panelItem.taskProjects.forEach(item => {
          if (item.projectType === 1) {
            projectIds.push(item.projectId)
          }
        });
        panelItem.projectIds = projectIds;

        let lisProjectIds = [];
        panelItem.taskLisProjects.forEach(item => {
          if (item.projectType === 1) {
            lisProjectIds.push(item.lisProjectId)
          }
        });

        panelItem.lisProjectIds = lisProjectIds;
      }

    },
    handlePhysicalType(item){

    },
    getNumPrefix(str) {
      const m = String(str).match(/^\d+/);
      return m ? m[0] : "";
    },
    openBloodTube(){
      this.initBloodTube(this.bloodTubeRemark);
      this.bloodTubeShow = true;
    },
    clearBloodTube(){
      for (let index = 0; index < this.bloodTubeList.length; index++) {
        let bloodTube = this.bloodTubeList[index];
        if(bloodTube.count > 0){
          bloodTube.count = 1;
        }
        this.bloodTubes[index].count = 0;
      }
      this.bloodTubeClearShow = false;
    },
    setBloodTube(){
      let bloodTubeCounts = [];
      for (let index = 0; index < this.bloodTubeList.length; index++) {
        let bloodTube = this.bloodTubeList[index];
        this.bloodTubes[index].count = bloodTube.count;
        if(bloodTube.show && bloodTube.count > 0){
          bloodTubeCounts.push(bloodTube.count + bloodTube.name.substring(0, 1));
        }
      }

      if(bloodTubeCounts && bloodTubeCounts.length > 0){
          this.bloodTubeClearShow = true;
          this.$emit("setBloodTubeCount", bloodTubeCounts.join("、"))
      }else{
        this.bloodTubeClearShow = false;
        this.$emit("setBloodTubeCount", "")
      }
      this.bloodTubeWindow = false;
    },
  }
};
</script>
<style lang="postcss" scoped>

.disable-area {
  pointer-events: none;
  opacity: 0.7;
}
</style>
